<template>
  <div style="display: none">
    <div ref="tooltip" style="min-width: 200px">
      <div style="margin-bottom: 5px">
        <span v-if="window.isDesktop">
          {{ place.id }} <b><a v-if="place.link" target="_blank" :href="place.link">{{ place.name }}</a><span v-else>{{
              place.name }}</span></b>&nbsp;<a :href="'https://maps.google.com/maps?q=' + place.lat + ',' + place.lon"
            target="_blank">{{ place.lat }}, {{ place.lon }}</a>
        </span>
        <span v-else>
          <b>{{ place.name }}</b>&nbsp;
          <a :href="'https://maps.google.com/maps?q=' + place.lat + ',' + place.lon" target="_blank">
            <img style="height: 12px; cursor: pointer" :src="icons.locationBlack" />
          </a>
        </span>
        <span style="float: right; margin-right: 16px;">
          <span v-if="place.from_type == $DataOrigin.maplas" :id="'tooltipPlaceApproved' + place.id"
            style='margin-right: 3px;'>
            <img style="height: 12px" :src="place.approved ? icons.approved : icons.question" />
          </span>
          <!--<b-tooltip v-if="window.isDesktop" placement="bottom" :target="'tooltipPlaceApproved' + place.id">{{ place.approved ? $t('placeApproved') : $t('placeNotApproved') }}</<b-tooltip>-->
          <!--<span :id="'tooltipPlaceFullRes' + place.id" v-if="place.photos.length" style='margin-right: 3px;' va-b-tooltip.hover:title="">
            &nbsp;<img ref="fullResImage" @click="makeFullResGallery" style="height: 12px; cursor: pointer" :src="icons.fullResolution" />
          </span>-->
          <!--<b-tooltip v-if="window.isDesktop" placement="bottom" :target="'tooltipPlaceFullRes' + place.id">{{ $t('fullRes') }}</<b-tooltip>-->
          <br>
        </span>
      </div>
      <div v-if="place.photos.length">
        <span style="text-align: center">
          <table v-if="((place.photos.length > 1) && (window.isDesktop))">
            <tr>
              <td @click="photoIndex != 0 ? prevPhoto() : null" style="padding: 0px"><img @load="resizePopup"
                  :style="{ width: '10px', height: '20px', cursor: photoIndex == 0 ? 'arrow' : 'pointer' }"
                  :src="photoIndex == 0 ? icons.arrowLeftDisabled : icons.arrowLeft"></td>
              <td style="padding-left: 5px; padding-right: 5px;"><img @load="resizePopup" ref="smallImage"
                  :src="place.photos[photoIndex].get_image_thumb()" class="popupimgbigmorephotos"
                  @click="(event) => makeGallery(event)"></td>
              <td @click="photoIndex != place.photos.length - 1 ? nextPhoto() : null" style="padding: 0px"><img
                  @load="resizePopup"
                  :style="{ width: '10px', height: '20px', cursor: photoIndex == place.photos.length - 1 ? 'arrow' : 'pointer' }"
                  :src="photoIndex == place.photos.length - 1 ? icons.arrowRightDisabled : icons.arrowRight"></td>
            </tr>
          </table>
          <img v-else @load="resizePopup" ref="smallImage" :src="place.photos[0].get_image_thumb()"
            :class="window.isDesktop ? 'popupimgbig' : 'popupimgsmall'" @click="(event) => makeGallery(event)">
        </span>
        <span v-if="window.isDesktop" style="float: right; color: gray"><br>{{ place.photos[0].org_filename }} {{
          formatDateSeconds(place.photos[0].exif_time_taken) }}<br></span>
      </div>
      <span v-if="place.videos.length">
        <div v-for="video in place.videos" :key="video.id">
          <b>{{ video.name }}</b> {{ video.description }}<br>
          <span style="text-align: center">
            <div v-html="video.html"></div>
          </span>
        </div>
      </span>
      <span v-if="window.isDesktop">{{ place.description }}<br></span>
      <span v-if="markerMoved()">
        <img @click="undoLocation" style="height: 20px; cursor: pointer;" :src="icons.undo" />&nbsp;
        <img @click="saveLocation" style="height: 20px; cursor: pointer;" :src="icons.save" />&nbsp;
      </span>
      <span v-if="(window.isDesktop) && (place.from_type == $DataOrigin.maplas) && ($store.state.user)"
        va-b-tooltip.hover :title="$t('editPlace')">
        <img @click="showEditPlaceModal" style="height: 20px; cursor: pointer;" :src="icons.upload" />
      </span>
      <img v-else style="height: 5px; width: 5px;" :src="icons.blankWhite" />
    </div>
    <div v-show="false" v-for="photo in place.photos" :key="photo.id">
      <span>{{ photo.get_image_fullhd() }}</span>
      <span>{{ photo.get_image_thumb() }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import Place from '@/ts/Place';
import axios from 'axios';
import { AlertStatus, DataOrigin } from '@/ts/types';
import { roundCoord } from '@/ts/utils/coords';
import { EventBus } from '@/ts/EventBus';
import lightGallery from 'lightgallery';
import lgZoom from 'lightgallery/plugins/zoom';
import lgAutoplay from 'lightgallery/plugins/autoplay';
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  extends: BaseComponent,
  data() {
    return {
      photoIndex: 0
    };
  },
  mounted() {
    this.place.getMarker().bindPopup(this.$refs.tooltip as HTMLElement, {});
    if (this.place.markerAction == 'click') {
      this.place.getMarker().openPopup();
    }
  },
  methods: {
    markerMoved() {
      if (this.place.from_type == DataOrigin.maplas) {
        return (this.place.markerLat != this.place.lat) || (this.place.markerLon != this.place.lon);
      } else {
        return false;
      }
    },
    prevPhoto() {
      this.photoIndex = this.photoIndex - 1;
      if (this.photoIndex == -1) {
        this.photoIndex = this.place.photos.length - 1;
      }
    },
    nextPhoto() {
      this.photoIndex = this.photoIndex + 1;
      if (this.photoIndex == this.place.photos.length) {
        this.photoIndex = 0;
      }
    },
    resizePopup() {
      //@ts-ignore
      this.place.getMarker()._popup.update();
    },
    undoLocation() {
      this.place.getMarker().setLatLng([this.place.lat, this.place.lon]);
      this.place.markerLat = this.place.lat;
      this.place.markerLon = this.place.lon;
    },
    async saveLocation() {
      const obj = { lat: roundCoord(this.place.getMarker().getLatLng().lat), lon: roundCoord(this.place.getMarker().getLatLng().lng) }
      try {
        const response = await axios.patch(window.apiHost + `api/places/${this.place.id}/`, obj);
        this.place.lat = obj.lat;
        this.place.lon = obj.lon;
        this.place.getMarker().setLatLng([this.place.lat, this.place.lon]);
        this.place.markerLat = this.place.lat;
        this.place.markerLon = this.place.lon;
        this.createAlert(AlertStatus.success, this.$t('placeCoordsSave').toString(), 2000);
      } catch {
        this.createAlert(AlertStatus.danger, this.$t('placeCoordsSaveError').toString(), 2000);
      }
    },
    showEditPlaceModal() {
      this.place.getMarker().closePopup();
      EventBus.$emit('openSavePlaceModal' + this.place.id);
    },
    galleryElements(maxRes: boolean) {
      const photos: Array<{ src: string, thumb: string }> = [];
      for (const photo of this.place.photos) {
        let photoToAdd = null;
        if (maxRes) {
          photoToAdd = { src: photo.image, thumb: photo.get_image_thumb() };
        } else {
          photoToAdd = { src: photo.get_image_fullhd(), thumb: photo.get_image_thumb() };
        }
        photos.push(photoToAdd);
      }
      return photos;
    },
    makeGallery(event: MouseEvent) {
      const photos = this.galleryElements(event.shiftKey || event.ctrlKey || event.altKey);
      const gallery = lightGallery(document.getElementById('map'), {
        dynamic: true,
        dynamicEl: photos,
        plugins: [lgZoom, lgAutoplay],
        showZoomInOutIcons: true,
        slideShowInterval: 3000,
        index: this.photoIndex,
        allowMediaOverlap: true,
        mobileSettings: {
          controls: false,
          showCloseIcon: true,
          download: false
        },
      });
      gallery.openGallery();
    }
  },
  props: {
    place: {
      required: true,
      type: Object as PropType<Place>
    }
  }
})


</script>

<style>
.popupimgbig {
  cursor: pointer;
  max-width: 300px;
  max-height: 300px;
}

.popupimgbigmorephotos {
  cursor: pointer;
  max-width: 270px;
  max-height: 270px;
}

.popupimgsmall {
  cursor: pointer;
  max-width: 200px;
  max-height: 200px
}

.leaflet-popup-content {
  margin: 8px !important;
}
</style>